import { writable } from 'svelte/store';
import type { Writable } from 'svelte/store';

// Create empty stores - will be populated by ExtractItems2.svelte
// (Currently from JSON files, later from backend service)
export const projectStructureStore: Writable<any> = writable({});
export const studyExtractStore: Writable<any> = writable({ topics: [] });
export const documentExtractStore: Writable<any> = writable({ tables: [] }); // For source table data (working data)
export const documentExtractFullStore: Writable<any> = writable({ topics: [] }); // For target data (full extract)

